import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from '../../util/reactIntl';
import { Form as FinalForm } from 'react-final-form';
import { ProfileSettingsModal, FieldTextEditor } from '../../components';
import css from './ProfileSettingsProfileDescriptionForm.css';

const InfoBoxStep = ({ number, children }) => (
  <div className={css.infoBoxStep}>
    <span className={css.infoBoxStepNumber}>{number}</span>
    <p className={css.infoBoxStepText}>{children}</p>
  </div>
);

const ProfileSettingsProfileDescriptionForm = props => {
  const {
    isOpen,
    onClose,
    onManageDisableScrolling,
    onSubmit,
    initialValue,
    updateInProgress,
    isCustomer,
    intl,
  } = props;

  return (
    <FinalForm
      key={isOpen}
      onSubmit={values => {
        onSubmit({ bio: values.bio });
        onClose();
      }}
      initialValues={{ bio: initialValue || '' }}
      render={({ handleSubmit, dirty }) => (
        <ProfileSettingsModal
          id="profileDescription"
          containerClassName={css.wideContainer}
          isOpen={isOpen}
          onClose={onClose}
          onManageDisableScrolling={onManageDisableScrolling}
          title={intl.formatMessage({ id: 'ProfileSettingsPage.editProfileDescriptionTitle' })}
          subtitle={intl.formatMessage({
            id: 'ProfileSettingsPage.editProfileDescriptionSubtitle',
          })}
          onSubmit={handleSubmit}
          submitDisabled={!dirty}
          submitInProgress={updateInProgress}
          submitLabel={intl.formatMessage({ id: 'ProfileSettingsPage.saveButton' })}
        >
          <div className={css.contentRow}>
            <div className={css.editorColumn}>
              <FieldTextEditor name="bio" id="bio" isBio />
            </div>
            <aside className={css.infoBox}>
              <div className={css.infoBoxHeader}>
                <span className={css.infoBoxIcon}>?</span>
                <p className={css.infoBoxTitle}>
                  {intl.formatMessage({ id: 'ProfileSettingsPage.bioInfoTitle' })}
                </p>
              </div>
              {isCustomer ? (
                <p className={css.infoBoxIntro}>
                  {intl.formatMessage({ id: 'ProfileSettingsPage.bioInfoBodyCustomer' })}
                </p>
              ) : (
                <>
                  <p className={css.infoBoxIntro}>
                    {intl.formatMessage({ id: 'ProfileSettingsPage.bioInfoIntro' })}
                  </p>
                  <div className={css.infoBoxSteps}>
                    <InfoBoxStep number={1}>
                      <FormattedMessage
                        id="ProfileSettingsPage.bioInfoStep1"
                        values={{
                          b: chunks => <strong className={css.infoBoxBold}>{chunks}</strong>,
                        }}
                      />
                    </InfoBoxStep>
                    <InfoBoxStep number={2}>
                      <FormattedMessage
                        id="ProfileSettingsPage.bioInfoStep2"
                        values={{
                          b: chunks => <strong className={css.infoBoxBold}>{chunks}</strong>,
                        }}
                      />
                    </InfoBoxStep>
                    <InfoBoxStep number={3}>
                      <FormattedMessage
                        id="ProfileSettingsPage.bioInfoStep3"
                        values={{
                          b: chunks => <strong className={css.infoBoxBold}>{chunks}</strong>,
                        }}
                      />
                    </InfoBoxStep>
                  </div>
                </>
              )}
            </aside>
          </div>
        </ProfileSettingsModal>
      )}
    />
  );
};

ProfileSettingsProfileDescriptionForm.defaultProps = {
  initialValue: '',
  updateInProgress: false,
  isCustomer: false,
};

ProfileSettingsProfileDescriptionForm.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onManageDisableScrolling: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValue: PropTypes.string,
  updateInProgress: PropTypes.bool,
  isCustomer: PropTypes.bool,
  intl: intlShape.isRequired,
};

export default injectIntl(ProfileSettingsProfileDescriptionForm);
